import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'
import { showAlert } from '../../../utility/SweetAlert'
import { useTranslation } from 'react-i18next'

const InteractorOrderUpdate = () => {
  const { t } = useTranslation()
  const orderUpdate = useCallback(
    (payload) => {
      ApiService.jsonRequest('/transaction-order/update', payload, (response) => {
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message:
              payload.status === 'DELIVERED'
                ? t('response_message.deliver_success')
                : payload.status === 'CANCELLED'
                ? t('response_message.order_cancelled')
                : t('response_message.send_success'),
            timer: 2000,
            redirect: '/order',
          })
        } else {
          showAlert({
            icon: 'warning',
            message: t('response_message.send_failed'),
            timer: 2000,
            reload: true,
          })
        }
      })
    },
    [t],
  )
  return { orderUpdate }
}

export default InteractorOrderUpdate
